// =============================================================================
// GENERATED by scripts/build-shared.cjs from functions/src/shared/revenueEntryCanon.js
// DO NOT EDIT — edit the canonical file and re-run `node scripts/build-shared.cjs`.
// (TASK-9872: one revenue row per ticket per live invoice — BI and the connector.)
//
// Side-effect module: attaches `window.RevenueCanon`. bi.js reads it at CALL time.
// =============================================================================
(function () {
  'use strict';

  /** The ONE live revenue row per ticket lives at this doc id (billing.js recordRevenueEntry). */
  var RC_DOC_PREFIX = 'tkt_';

  function rcDocId(ticketId) {
    return RC_DOC_PREFIX + String(ticketId);
  }

  /** billing.js isTicketInvoiced, verbatim semantics. */
  function rcTicketInvoiced(t) {
    t = t || {};
    return t.invoiced === true || !!t.invoiceNumber || !!t.invoicedAt;
  }

  /** Milliseconds from a Firestore Timestamp / Date / ISO string / {seconds}; -Infinity when unusable. */
  function rcMs(v) {
    if (v === null || v === undefined) return -Infinity;
    if (typeof v.toMillis === 'function') return v.toMillis();
    if (typeof v.toDate === 'function') return v.toDate().getTime();
    if (v instanceof Date) return v.getTime();
    if (typeof v === 'number') return isFinite(v) ? v : -Infinity;
    if (typeof v === 'string') { var n = Date.parse(v); return isNaN(n) ? -Infinity : n; }
    if (typeof v === 'object' && typeof v.seconds === 'number') return v.seconds * 1000;
    if (typeof v === 'object' && typeof v._seconds === 'number') return v._seconds * 1000;
    return -Infinity;
  }

  function rcInvNo(v) {
    return v === null || v === undefined || v === '' ? null : String(v);
  }

  /**
   * Why a row can never count on its own, or null.
   * @param r      revenueEntries row
   * @param ticket undefined = not looked up; null = no ticket doc; object = the ticket
   */
  function rcRowExclusion(r, ticket) {
    if (!r) return 'empty';
    // A known ticket's LIVE state wins over the row's own void mark: a ticket
    // un-invoiced and later re-marked invoiced (Billing's "mark invoiced" box —
    // before TASK-9942 it wrote no revenue row) counts again, exactly as before voids.
    if (ticket) {
      if (ticket.status === 'deleted') return 'ticket_deleted';
      if (!rcTicketInvoiced(ticket)) return 'ticket_not_invoiced';
      return null;
    }
    if (r.voided === true) return 'voided';
    return null;
  }

  /** Winner order among one ticket's rows: not voided, then paid, then newest write, then id. */
  function rcBetter(a, b) {
    var av = a.voided === true ? 0 : 1;
    var bv = b.voided === true ? 0 : 1;
    if (av !== bv) return av > bv;
    var ap = a.paid === true ? 1 : 0;
    var bp = b.paid === true ? 1 : 0;
    if (ap !== bp) return ap > bp;
    var am = Math.max(rcMs(a.createdAt), rcMs(a.invoicedAt));
    var bm = Math.max(rcMs(b.createdAt), rcMs(b.invoicedAt));
    if (am !== bm) return am > bm;
    return String(a.id || '') > String(b.id || '');
  }

  /**
   * The rows that count, in INPUT order (BI's snapshot order is load-bearing for
   * its rental-slice selector), plus every dropped row with its reason.
   *
   * @param {object[]} entries  revenueEntries rows ({id, ...data})
   * @param {Map|object|function|null} tickets  ticketId -> ticket doc (null = doc
   *        missing). Anything not found is treated as "not looked up".
   * @returns {{rows: object[], dropped: {row: object, reason: string, keptId: (string|null)}[]}}
   */
  function canonicalRevenueEntries(entries, tickets) {
    var list = Array.isArray(entries) ? entries : [];
    var ticketOf = function (id) {
      if (!tickets || id === null || id === undefined) return undefined;
      if (typeof tickets === 'function') return tickets(id);
      if (typeof tickets.get === 'function') return tickets.has(id) ? tickets.get(id) : undefined;
      return Object.prototype.hasOwnProperty.call(tickets, id) ? tickets[id] : undefined;
    };
    var dropped = [];
    var survivors = [];
    var groups = Object.create(null);
    var i;
    for (i = 0; i < list.length; i++) {
      var r = list[i];
      var why = rcRowExclusion(r, r ? ticketOf(r.ticketId) : undefined);
      if (why) { dropped.push({ row: r, reason: why, keptId: null }); continue; }
      survivors.push(r);
      if (r.ticketId !== null && r.ticketId !== undefined && r.ticketId !== '') {
        var k = String(r.ticketId);
        (groups[k] = groups[k] || []).push(r);
      }
    }
    var winners = Object.create(null);
    for (var key in groups) {
      var g = groups[key];
      if (g.length === 1) { winners[key] = g[0]; continue; }
      var t = ticketOf(key);
      var cur = t ? rcInvNo(t.invoiceNumber) : null;
      var pool = g;
      if (cur !== null) {
        var match = [];
        for (i = 0; i < g.length; i++) if (rcInvNo(g[i].invoiceNumber) === cur) match.push(g[i]);
        if (match.length) pool = match;
      }
      var best = pool[0];
      for (i = 1; i < pool.length; i++) if (rcBetter(pool[i], best)) best = pool[i];
      winners[key] = best;
    }
    var rows = [];
    for (i = 0; i < survivors.length; i++) {
      var s = survivors[i];
      if (s.ticketId === null || s.ticketId === undefined || s.ticketId === '') { rows.push(s); continue; }
      var w = winners[String(s.ticketId)];
      if (w === s) { rows.push(s); continue; }
      dropped.push({
        row: s,
        reason: rcInvNo(s.invoiceNumber) === rcInvNo(w.invoiceNumber) ? 'duplicate_same_invoice' : 'superseded_invoice',
        keptId: w.id || null,
      });
    }
    return { rows: rows, dropped: dropped };
  }

  window.RevenueCanon = Object.freeze({
    DOC_PREFIX: RC_DOC_PREFIX,
    docId: rcDocId,
    ticketInvoiced: rcTicketInvoiced,
    ms: rcMs,
    rowExclusion: rcRowExclusion,
    canonicalRevenueEntries: canonicalRevenueEntries
  });
})();
